import { apiRequest } from '../api/client';
import { API_ENDPOINTS, withParams } from '../config/apis';

export type HomepageMember = {
  id: number;
  name: string;
  phoneNumber: string;
  gender: string | null;
  birthDate: string | null;
};

export type HomepageMemberListResponse = {
  members: HomepageMember[];
  totalCount: number;
  page: number;
  size: number;
};

export type HomepageMemberUpdateRequest = {
  name?: string;
  gender?: string;
  birthDate?: string;
};

export const memberService = {
  list: (page: number, size: number, keyword = '') =>
    apiRequest<HomepageMemberListResponse>(API_ENDPOINTS.memberList, {
      query: { page, size, keyword },
    }),

  update: (memberId: number, body: HomepageMemberUpdateRequest) =>
    apiRequest<HomepageMember, HomepageMemberUpdateRequest>(
      withParams(API_ENDPOINTS.memberUpdate, { memberId }),
      { body }
    ),

  delete: (memberId: number) =>
    apiRequest<void>(withParams(API_ENDPOINTS.memberDelete, { memberId })),
};
